// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__vi+-n","image":"NotFound_image__eDf7R","image__notfoundtext":"NotFound_image__notfoundtext__EsOlZ","image__announce":"NotFound_image__announce__XHxud"};